import { render } from "./MailSignupView.vue?vue&type=template&id=25e846fb"
import script from "./MailSignupView.vue?vue&type=script&lang=js"
export * from "./MailSignupView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/ecu-tablet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__